<div class="ruckit-job-reference-cell">
  <job-reference-selector
    #jobReferenceSelector
    (referenceSelected)="onReferenceClicked($event)"
    (onClose)="onReferenceClosed()"
  ></job-reference-selector>
</div>
